export default __webpack_public_path__ + "static/media/zucchinaTtsIt_It60.4a841d33.mp3";